import React, { useEffect, useState } from 'react';
import './SearchField.css';
import { SearchCheck, X } from 'lucide-react';
//import { useDebounce } from "./hooks/useDebounce";
/**
 * SearchField:
 * - n'appelle onChange/onSearch qu'au submit ou au reset.
 * - conserve un internalValue pour taper sans lancer la recherche à chaque frappe.
 * - si la prop value est fournie, on la synchronise (utile pour Restore).
 *
 * Props:
 * - label
 * - onSearch(value)    -> appelé au submit et au reset
 * - value (optionnel)  -> si fourni, composant synchronisé depuis le parent (restore)
 * - onChange (optionnel) -> appelé au submit/reset pour conserver la compatibilité
 * - collapsed (optionnel)
 */
const SearchField = ({ label, onSearch, value, onChange, collapsed = false }) => {
  const isControlled = value !== undefined;

  // internalValue garde la saisie pendant la frappe
  const [internalValue, setInternalValue] = useState(value ?? '');
  const [active, setActive] = useState((value ?? '').toString().trim() !== '');

  // Sync when parent forces a value (restore)
  useEffect(() => {
    if (isControlled) {
      setInternalValue(value ?? '');
      setActive((value ?? '').toString().trim() !== '');
    }
  }, [value, isControlled]);

  // On frappe: onChange local seulement (pas d'appel parent)
  const handleInputChange = (e) => {
    setInternalValue(e.target.value);
    // on purpose: do NOT call parent onChange here to avoid launching search on each key
  };

  // Submit: onSearch and onChange are called with the current value
  const handleSubmit = (e) => {
    e.preventDefault();
    const v = (internalValue ?? '').toString().trim();
    if (typeof onSearch === 'function') onSearch(v);
    if (typeof onChange === 'function') onChange(v);
    setActive(v !== '');
  };

  // Reset: clear local value and notify parent
  const handleReset = () => {
    setInternalValue('');
    if (typeof onSearch === 'function') onSearch('');
    if (typeof onChange === 'function') onChange('');
    setActive(false);
  };

  if (collapsed) {
    return (
      <button className="search-btn" onClick={() => {/* ouvrir ce champ */ }}>
        <SearchCheck size={16} strokeWidth={2.5} />
      </button>
    );
  }

  const shownValue = internalValue;

  return (
    <form className="search-field" onSubmit={handleSubmit}>
      <div className={`search-wrapper ${active ? 'active' : ''}`}>
        <input
          type="text"
          className="search-input"
          value={shownValue}
          onChange={handleInputChange}
          placeholder={`Rechercher ${label.toLowerCase()}…`}
          id={"search-"+label}
        />
        {shownValue && shownValue.toString().trim() !== '' && (
          <button type="button" className="reset-btn" onClick={handleReset}>
            <X />
          </button>
        )}
      </div>
      <button type="submit" className="search-btn">
        <SearchCheck size={16} strokeWidth={2.0} />
      </button>
    </form>
  );
};

export default SearchField;
